import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {catchError, map, publishReplay, refCount} from 'rxjs/operators';
import {Observable, throwError} from 'rxjs';
import {ErrorDataService} from './error-data.service';
import {factory} from '../shared/app-logging';
import {AppConfig} from '../shared/app-config';
import {PollyVoice} from '../model/polly-voice';

const logger = factory.getLogger('PollyService');

@Injectable({
  providedIn: 'root'
})
export class PollyService {
  private availableVoices: Observable<Array<PollyVoice>>;
  private availableVoicesLastCallError = false;

  constructor(private httpClient: HttpClient) {
  }

  public getAvailableVoices(): Observable<Array<PollyVoice>> {
    if (this.availableVoices && !this.availableVoicesLastCallError) {
      logger.debug('getAvailableVoices: Cache hit.');
    }
    this.availableVoices = (this.availableVoices && !this.availableVoicesLastCallError) ? this.availableVoices : this.fetchAvailableVoices();
    return this.availableVoices;
  }

  private fetchAvailableVoices(): Observable<Array<PollyVoice>> {
    const urlService = AppConfig.urlPollyVoices;
    return this.httpClient.post(environment.contentLibraryApiBaseUrl + urlService, {})
      .pipe(map(
        (response: HttpResponse<any>) => {
          const voices = new Array<PollyVoice>();
          if (response['data']) {
            logger.debug(`getAvailableVoices: ${response['data'].Voices.length} Polly Voices fetched from REST`);
            if (response['data'].NextToken) {
              // recursive stuff not needed yet
              logger.debug(`getAvailableVoices(): Next Token= ${response['data'].NextToken}`);
            }
            for (const item of response['data'].Voices) {
              voices.push(new PollyVoice(item.Id, item.Gender, item.LanguageCode, item.LanguageName, item.Name));
            }
          }
          this.availableVoicesLastCallError = false;
          return voices;
        }
        ), catchError((err: Error | HttpErrorResponse) => {
          const message = `In PollyService.getAvailableVoices().`;
          this.availableVoicesLastCallError = true;
          return throwError(ErrorDataService.overLoadError(err, message));
        }),
        publishReplay(1),
        refCount());
  }
}
